import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Hammer } from 'lucide-react';

import { useSelf } from '@/data/user';

const Page = () => {
  const user = useSelf();

  return (
    <>
      <Alert variant="destructive" className="mb-4">
        <Hammer size={18} />
        <AlertTitle>Beta</AlertTitle>
        <AlertDescription>
          Welcome to Profound! Please note that we are currently in beta. Your
          feedback is valuable as we continue to improve our platform.
        </AlertDescription>
      </Alert>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            Welcome {user.data.firstname} {user.data.lastname}
          </CardTitle>
          <CardDescription>Dashboard</CardDescription>
        </CardHeader>
        <CardContent>
          Latest Bookings? <br />
          Coaches that need approval
        </CardContent>
      </Card>
    </>
  );
};

export default Page;
